import React, {useEffect}from 'react';
import { Singleton } from '../../../js/Singleton.js';
import { STATES_TO_SHOW_CTC, USER_STATE} from '../../../constants.js';
import {  useSelector,useDispatch } from 'react-redux';
import { SingletonSharedData } from '../../../js/singletonSharedData.js';
import CardPreviewRecord from './CardPreviewRecord/CardPreviewRecord.jsx';
import { UncontrolledTooltip } from 'reactstrap';
import ChangeTypeCampaign from '../CallComponents/ChangeTypeCampaign/ChangeTypeCampaign.jsx';
import ContainerSimultaneousRec from './ContainerSimultaneousRec.jsx';
import { actionResponseTransfer } from '../../../redux/actions/A_messages_to_SM.js';
import { showPreviewData,setUnnasignByXfer } from '../../../redux/actions/A_preview_transfer.js';
import { cleanData } from '../../../redux/actions/A_preview.js';
import { messageToStateMachine } from '../../../redux/actions/A_messages_to_SM.js';
import { messageAgentRedy } from '../../../js/helpers/helperMessages.js';
const language = new Singleton();
const sharedData = new SingletonSharedData();

  const CallWindowSimultaneosPreview = () =>{
  const {records, defaultDialingRate, selectedRecord:{callOutId}, countRecordsDialing,previewType} = useSelector(state => state.preview);
  const { allowChangeDialing } = useSelector(state=>state.agentPermissions);
  const {unnasignByXfer,mainAgent} = useSelector(state => state.previewActions);
  const {userState} = useSelector(state => state)
  const dispatch = useDispatch();
  
  useEffect(() => {
    if(unnasignByXfer && records.length === 0)
    {
      dispatch(cleanData());
      setTimeout(() => {dispatch(showPreviewData(false))},50);
      setTimeout(() => {dispatch(actionResponseTransfer(mainAgent, 1))}, 50);
      dispatch(setUnnasignByXfer({flag:false, mainAgent: ''}))
    }
  }, [unnasignByXfer,records.length])
    useEffect(() => {
    if(records.length === 0 && previewType === 2 && userState.currentState === USER_STATE.AGENT_PREVIEW)
    {
      setTimeout(()=>{
        if(userState.currentState === USER_STATE.AGENT_PREVIEW)
        {
          dispatch(messageToStateMachine(messageAgentRedy()));
        }
      },3500)
    }
  }, [records.length])
  
  return(
    <div className="cwsp-container">
       <div className='cwsp-containerRec'>
        <div className='cwsp-container-information'>
          <div className='cwsp-general-information'>
            <p className='cwsp-label'>{language.getText('GUIPreviewsimultaneousView')}</p>
            <div className='cwsp-simultaneousRec' id='cwsp-simultaneousRec'>{defaultDialingRate-countRecordsDialing}</div>
            <UncontrolledTooltip  innerClassName='cwsp-tooltip-dialing-rate' placement='top' target='cwsp-simultaneousRec' boundariesElement='window'>{language.getText('GUIPreviewcallsLimit')}</UncontrolledTooltip>
          </div>
          {(allowChangeDialing && sharedData.getDataPreviewPro().dialingMode && STATES_TO_SHOW_CTC.includes(userState.currentState)) &&
            <div className='cwsp-selection'>
              <ChangeTypeCampaign /> 
            </div>
          }
        </div>

        <div className='cwsp-records'>
          {
            records.map(r => (
                <CardPreviewRecord
                  key={r.callOutId}
                  data1={r.data[0]}
                  data2={r.data[1]}
                  record={r}
                  defaultDialingRate={defaultDialingRate}
                />
              
            ))
          }
        </div>
      </div>
      {
        callOutId !== 0 &&
        <ContainerSimultaneousRec/>
      } 
    </div>  
  )
}

export default CallWindowSimultaneosPreview;



// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/CallWindowSimultaneosPreview.jsx